import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FreelanceProfileComponent } from './freelanceProfile.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [FreelanceProfileComponent],
  exports: [
    FreelanceProfileComponent
  ],
  providers: [
  ]
})
export class FreelanceProfileModule { }
